exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".mercado-pago-button{display:flex;align-items:center;font-weight:700;background-color:#fd0;color:#333;border-color:#fd0}.mercado-pago-button .logo-mercado-pago{width:24px;height:24px;margin-right:8px}", ""]);

// exports
